import { render, staticRenderFns } from "./NumberOfBuyersBarChart.vue?vue&type=template&id=38b8c71b&"
import script from "./NumberOfBuyersBarChart.vue?vue&type=script&lang=ts&"
export * from "./NumberOfBuyersBarChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports